'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _feedback = require('./feedback.html');

var _feedback2 = _interopRequireDefault(_feedback);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _feedback2.default,
  transclude: {
    actionButtons: '?actionButtons'
  },
  bindings: {
    onFeedbackSubmitted: '&'
  },
  controller: function () {
    function FeedbackComponent(EventEmitter) {
      'ngInject';

      _classCallCheck(this, FeedbackComponent);

      Object.assign(this, { EventEmitter: EventEmitter });
    }

    _createClass(FeedbackComponent, [{
      key: 'onSubmit',
      value: function onSubmit() {
        this.onFeedbackSubmitted(this.EventEmitter({
          feedback: this.feedback
        }));
      }
    }]);

    return FeedbackComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/common/feedback/feedback.component.js